import { ServiceResponse, AddressSearchResultsDto, AddressDto } from "../../platform/models";


const IAddressLookupServiceId = Symbol("IAddressLookupService");

interface IAddressLookupService {
    searchAddresses(searchTerm: string, antiForgeryToken: string) : Promise<ServiceResponse<AddressSearchResultsDto>>;
    
    getAddress(addressId: string, antiForgeryToken: string) : Promise<ServiceResponse<AddressDto>>;
};

export { IAddressLookupServiceId, IAddressLookupService }